import React from 'react';

export const CodeLensIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <circle cx="10.5" cy="10.5" r="7" />
    <path d="m21 21-5.2-5.2" />
    <path d="m8.6 8.3-1.8 2.2 1.8 2.2M12.4 8.3l1.8 2.2-1.8 2.2" />
  </svg>
);